import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import dayjs from "dayjs"
import "dayjs/locale/vi"
import relativeTime from "dayjs/plugin/relativeTime"
import timezone from 'dayjs/plugin/timezone';
import utc from "dayjs/plugin/utc"

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale("vi")

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number): string {
	return new Intl.NumberFormat("vi-VN", {
		style: "currency",
		currency: "VND",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(amount)
}

/**
 * Formats a date in Vietnamese relative time (e.g., "2 giờ trước")
 * @param date - Date string, Date object, or timestamp to format
 * @returns Formatted date string in Vietnamese relative time
 */
export function formatRelativeTime(date: string | Date | number): string {
	return dayjs(date).locale("vi").fromNow()
}

/**
 * Formats a Unix timestamp in Vietnamese relative time (e.g., "2 giờ trước")
 * @param unixTime - Unix timestamp in seconds (10 digits)
 * @returns Formatted date string in Vietnamese relative time
 */
export function formatUnixTime(unixTime: number): string {
	// Convert Unix timestamp (seconds) to milliseconds for dayjs
	return dayjs(unixTime * 1000).locale("vi").fromNow()
}
